export const API_URL = `${process.env.REACT_APP_API_URL || ""}/api`;
export const SSE_URL = `${process.env.REACT_APP_API_URL || ""}/sse`;
export const HUB_URL = `${process.env.REACT_APP_API_URL || ""}/hubs`;
